import api from "./axios";
import type {
  FeedbackFormType,
  TicketType,
  TopicItem,
} from "@/struct/FeedbackStruct";
import type { ApiResponseEnvelope } from "@/struct/ApiEnvelope";

export default class FeedbackService {
  getTopics = () => {
    return api.get<ApiResponseEnvelope<TopicItem[]>>(
      "/api/web-api/integration/otrs/get-topics"
    );
  };
  sendFeedback = (data: FeedbackFormType) => {
    return api.post("/api/web-api/rating/create", { ...data });
  };
  sendTicket = (data: TicketType) => {
    return api.post("/api/web-api/integration/otrs/send-ticket", { ...data });
  };
}
